<!--
 * @Description: 
 * @Autor: wk
 * @Date: 2019-11-25 15:08:25
 * @LastEditors: 一诺(丘汉文)
 * @LastEditTime: 2020-05-12 14:46:14
-->
<template>
  <div class="message-box-view">
    <div class='message-auto'>
      <div
        class="message-item"
        v-for="item of messageList"
        :key="item.id"
        :title="item.messageContent"
        @click="handleReadMessage(item)">
        <div class='message-title'>
          <span>{{item.messageTitle}}</span>
          <span>{{item.dataString}}</span>
        </div>
        <div class='message-body'>{{item.messageContent}}</div>
      </div>
    </div>
    <div class="no-message" v-show="total === 0">暂无消息</div>
    <footer class="more-message" v-show="total > 2">
      <router-link target="_blank" to="/sendSms/myMessage">查看更多</router-link>
    </footer>
  </div>
</template>

<script>
import { clearTimeout } from 'timers'
import * as http from './work.service'

export default {
  name: 'MessageBox',
  data() {
    return {
      messageList: [],
      empId: '',
      total: 0,
      timer: null
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化，需要确保获取到了empId所以用到promise
    init() {
      const userster = localStorage.getItem('users')
      new Promise((resolve) => {
        this.timer = setInterval(() => {
          if (userster !== 'undefined') {
            resolve(userster)
          }
        }, 20)
      }).then((data) => {
        clearInterval(this.timer)
        if (data) {
          data = JSON.parse(data)
        }
        this.empId = data ? data.empId : ''
        if (this.empId) {
          // 先执行请求，然后设置每隔2min刷新一次数据
          this.queryUnreadMessage()
          setTimeout(() => {
            this.queryUnreadMessage()
          }, 1000 * 60 * 2)
        } else {
          setTimeout(() => {
            this.init()
            console.log('没有获取到empId')
          }, 1000)
        }
      }).catch(() => {
        clearInterval(this.timer)
      })
    },
    // 查询前十条未读消息
    queryUnreadMessage() {
      http.findByNoReadBeforeTenMessageList({ empId: this.empId }).subscribe((res) => {
        res = res.response.data
        if (res.code === 0 && !res.msg) {
          this.messageList = res.data
          this.total = res.total
          this.$emit('input', this.total)
        }
      })
    },
    // 设置未读消息成已读
    handleReadMessage(data) {
      const param = {
        empId: this.empId,
        ids: data.id
      }
      http.batchUpdateToRead(param).subscribe((res) => {
        res = res.response.data
        if (res.code === 0) {
          this.handleJumpUrl(data)
        }
      })
    },
    // 处理消息，根据后台返回的url跳转 参数后台已经拼接
    handleJumpUrl({ jumpUrl }) {
      clearInterval(this.timer)
      this.init()
      http.findByJumpUrl({ loginId: this.empId, entranceType: 1, woCode: jumpUrl }).subscribe(
        (res) => {
          if (res.data) {
            const url = window.location.origin + res.data
            window.open(url)
          }
        }
      )
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>

<style lang="less" scoped>
.message-box-view{
  border-top: 1px solid #DCDFE6;
  .message-item{
    border-bottom: 1px solid #DCDFE6;
    cursor: pointer;
    padding: 8px 10px;
    .message-title{
      display: flex;
      line-height: 28px;
      justify-content: space-between;
      font-weight: 550;
      color: #333333;
      font-size: 13px;
    }
    .message-body{
      color: #999999;
      font-size: 12px;
      overflow:hidden; 
      text-overflow:ellipsis;
      display:-webkit-box; 
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2; 
    }
  }
  .no-message{
    text-align: center;
    padding: 30px 
  }
  .more-message{
    text-align: right;
    line-height: 32px;
    a{
      color: #409EFF;
    }
  }
}
.message-auto{
  max-height: 400px;
  overflow: auto;
}
/*滚动条样式*/
.message-auto::-webkit-scrollbar {/*滚动条整体样式*/
    width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
}
.message-auto::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: rgba(0,0,0,0.2);
}
.message-auto::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 0;
    background: rgba(0,0,0,0.1);
}
</style>
